import {
  FETCH_SUPPORT_TICKETS_REQUEST,
  FETCH_SUPPORT_TICKETS_SUCCESS,
  FETCH_SUPPORT_TICKETS_FAILURE,

  FETCH_SINGLE_SUPPORT_TICKET_REQUEST,
  FETCH_SINGLE_SUPPORT_TICKET_SUCCESS,
  FETCH_SINGLE_SUPPORT_TICKET_FAILURE,

  CREATE_SUPPORT_TICKET_REPLY_REQUEST,
  CREATE_SUPPORT_TICKET_REPLY_SUCCESS,
  CREATE_SUPPORT_TICKET_REPLY_FAILURE,
} from '../actions/actions'

export default function supportTickets(state = {}, action) {
  switch (action.type) {
    //********************************************************/
    case FETCH_SUPPORT_TICKETS_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_SUPPORT_TICKETS_SUCCESS:
      const { data } = action
      return { ...data, count: data.count, isLoading: false }

    case FETCH_SUPPORT_TICKETS_FAILURE:
      return { ...state, isLoading: false }

    //********************************************************/
    case FETCH_SINGLE_SUPPORT_TICKET_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_SINGLE_SUPPORT_TICKET_SUCCESS:
      const { data: { ticket } } = action
      return { ...state, ticket, isLoading: false }

    case FETCH_SINGLE_SUPPORT_TICKET_FAILURE:
      const { data: errors } = action
      return { ...state, errors, isLoading: false }

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/support.js